// extracted by mini-css-extract-plugin
module.exports = {"message":"DropdownModal_message__2oV8U","buttons":"DropdownModal_buttons__soWkt","submitButton":"DropdownModal_submitButton__kkGZJ"};